import React from "react";
import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { GrFormAdd } from "react-icons/gr";
import { handleValidNumber2 } from "src/utils/formUtils/ValidNumber";
import { MdDelete } from "react-icons/md";
import { ProductManagementFormValues } from "src/models/ProductManagement.model";
import useModes from "src/hooks/useMode";
import useBook from "src/hooks/useBook";
import { RiDeleteBin5Line } from "react-icons/ri";
import { getInputHeight } from "src/utils/formUtils/getInputHeight";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import { setIsOpenAddDialog } from "src/redux/slices/ProductManagementSlice";
import { useDispatch } from "react-redux";

type Props = {
  formikProps: FormikProps<ProductManagementFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const ProductManagement = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { modes, isDataLoading } = useModes();
  const { book, isDataLoading: isBookDataLoading } = useBook();

  const getBookOptions = book?.map((book) => {
    return { value: book._id, label: book.bookName };
  });
  const ModeOptions = modes?.map((modes: any) => {
    return {
      label: modes?.modeName,
      value: modes?._id,
    };
  });
  const dispatch = useDispatch();
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add product" : "Update Product"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            placeholder="Enter Title"
            name="title"
            value={values.title}
            required
            onChange={(e) => {
              setFieldValue("title", e.target.value);
            }}
            label="Title"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <p className="border-l-2 px-2 mt-3 border-black font-medium">
            Variants
          </p>
          {/* Label Name */}
          <FieldArray name="variants">
            {({ push, remove }) => (
              <div className="flex flex-col ">
                {values?.variants?.map((amount: any, index: any) => (
                  <>
                    <div className="flex justify-end">
                      {/* Delete Button */}
                      <button
                        type="button"
                        className={`'}  text-red-700  flex justify-center items-center `}
                        onClick={() => remove(index)}
                      >
                        <MdDelete size={20} />
                      </button>
                    </div>
                    <div key={index} className="flex gap-4 items-end mb-2">
                      <div>
                        <ATMSelect
                          isLoading={isDataLoading}
                          name={`variants[${index}].modeId`}
                          placeholder="Mode"
                          label="Mode"
                          options={ModeOptions}
                          onChange={(newValue: any) => {
                            setFieldValue(
                              `variants[${index}].modeId`,
                              newValue
                            );
                          }}
                          value={values.variants[index].modeId}
                        />
                      </div>
                      <div className="">
                        <ATMTextField
                          name={`variants[${index}].noOfViews`}
                          value={values.variants[index].noOfViews}
                          onChange={(e) =>
                            setFieldValue(
                              `variants[${index}].noOfViews`,
                              e.target.value
                            )
                          }
                          label=" No Of Views"
                          placeholder="Enter No. of views"
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="">
                        <ATMTextField
                          name={`variants[${index}].batchRecording`}
                          value={values.variants[index].batchRecording}
                          onChange={(e) =>
                            setFieldValue(
                              `variants[${index}].batchRecording`,
                              e.target.value
                            )
                          }
                          label=" Batch Recording"
                          placeholder=" Enter Batch Recording"
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="">
                        <ATMTextField
                          name={`variants[${index}].price`}
                          value={values.variants[index].price}
                          onChange={(e) =>
                            handleValidNumber2(e) &&
                            setFieldValue(
                              `variants[${index}].price`,
                              e.target.value
                            )
                          }
                          label="Price"
                          placeholder="Enter price"
                          onBlur={handleBlur}
                        />
                      </div>
                    </div>
                  </>
                ))}

                {/* Add More Button */}
                <button
                  type="button"
                  onClick={() =>
                    push({
                      title: "",
                      price: "",
                      position: "",
                      mode: "",
                      noOfViews: "",
                    })
                  }
                  className="rounded border-dashed border border-slate-500  font-medium text-md mt-[15px]  text-gray-400 flex justify-center items-center gap-[2px] "
                >
                  Add {values?.variants?.length ? "More" : "Variants"}{" "}
                  <span>
                    <GrFormAdd
                      color="#ADB8C8"
                      size="1.5em"
                      className="font-semibold"
                    />
                  </span>
                </button>
              </div>
            )}
          </FieldArray>
        </div>

        <div>
          <ATMMultiSelect
            isLoading={isBookDataLoading}
            name={`books`}
            required
            showAddButton
            placeholder="select book"
            label="books"
            options={getBookOptions}
            onClickShareAddButton={() => dispatch(setIsOpenAddDialog(true))}
            onChange={(newValue: any) => {
              setFieldValue(`books`, newValue);
            }}
            value={values.books}
          />
        </div>
        <div className="my-6">
          <p className="border-l-2 px-2 mt-3 border-black font-medium">
            images
          </p>
          {/* Label Name */}
          <FieldArray name="images">
            {({ push, remove }) => (
              <div className="grid grid-cols-4 gap-3 ">
                {values?.images?.map((book: any, index: any) => (
                  <div key={index} className="flex gap-4 items-end">
                    {/* Book Name*/}
                    <div className="">
                      <ATMTextField
                        name={`images[${index}]`}
                        value={values.images[index]}
                        onChange={(e) =>
                          setFieldValue(`images[${index}]`, e.target.value)
                        }
                        label="images"
                        placeholder="Enter imange url"
                        onBlur={handleBlur}
                      />
                    </div>

                    {/* Delete Button */}
                    <button
                      type="button"
                      className={`${getInputHeight(
                        "small"
                      )} aspect-square rounded bg-red-400 text-white flex justify-center items-center `}
                      onClick={() => remove(index)}
                    >
                      <RiDeleteBin5Line size={20} />
                    </button>
                  </div>
                ))}

                {/* Add More Button */}
                <button
                  type="button"
                  onClick={() =>
                    push({
                      images: "",
                    })
                  }
                  className="rounded border-dashed mt-2 border border-slate-500 py-2 font-medium text-md text-gray-400 flex justify-center items-center gap-[2px]"
                >
                  Add {values?.images?.length ? "More" : "Images"}{" "}
                  <span>
                    <GrFormAdd
                      color="#ADB8C8"
                      size="1.5em"
                      className="font-semibold"
                    />
                  </span>
                </button>
              </div>
            )}
          </FieldArray>
        </div>

        <div>
          <ATMTextArea
            name="description"
            value={values.description}
            onChange={(e) => {
              setFieldValue("description", e);
            }}
            label="Description"
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ProductManagement;
